{
    "Title": "Warteschlangen verwalten",
    "ManageQueuesDescriptionTitle": "Beschreibung",
    "ManageQueuesCQConfigurationsTitle": "CQ-Konfigurationen",
    "ManageQueuesResourceAccountsTitle": "Ressourcenkonten",
    "ManageQueuesMonitoringStatusTitle": "Überwachungsstatus",
    "ManageQueueFiltersTitle": "Filter",
    "ManageQueueCallMonitoringHistoric": "Historisch",
    "ManageQueueCallMonitoringRealTime": "Echtzeit",
    "ManageQueueCallMonitoringRealTimeForced": "Echtzeit (erzwungen)",
    "ManageQueueCallMonitoringUnknown": "Unbekannt",
    "ManageQueueCallCQConfigurationCompatible": "Kompatibel",
    "ManageQueueCallCQConfigurationIncompatible": "Unvereinbar",
    "ManageQueuesQueueFilterAll": "Alle Warteschlangen",
    "ManageQueuesFilterCompatible": "Kompatible Warteschlangen",
    "ManageQueuesFilterIncompatible": "Inkompatible Warteschlangen",
    "ManageQueue_DisableEnableRealtime_Confirm": "Bestätigen",
    "ManageQueue_DisableEnableRealtime_Cancel": "Stornieren",
    "ManageQueue_MonitorAllMessage": "Möchten Sie die Echtzeitüberwachung für alle Warteschlangen wirklich aktivieren?",
    "ManageQueue_UnmonitorAllMessage": "Möchten Sie die Echtzeitüberwachung für alle Warteschlangen wirklich deaktivieren?",
    "ManageQueue_Loading_Monitoring_All": "Aktivieren der Echtzeitüberwachung für alle Warteschlangen",
    "ManageQueue_Loading_Unmonitoring_All": "Deaktivieren der Echtzeitüberwachung für alle Warteschlangen",
    "ManageQueue_Pending_Queue_Disabling": "Überwachung wird deaktiviert...",
    "ManageQueue_Pending_Queue_Enabling": "Überwachung wird aktiviert...",
    "ManageQueue_Disable_RT_Popper": "Deaktivieren Sie die Echtzeitüberwachung für alle Warteschlangen",
    "ManageQueue_Enable_RT_Popper": "Aktivieren Sie die Echtzeitüberwachung aller Warteschlangen",
    "ManageQueues_Not_Found_Error": "Es wurden keine Warteschlangen gefunden, die dieser Suche entsprechen",
    "NAME": "ManageQueues"
}